import { ISpecialFeatureMapValue, ISpecialFeatureMessage } from '../classes/package-listing';
import { IPerformance } from '../custom/classes/production';

export function createSpecialFeatureMap(allMergedPerformances: IPerformance[], specialFeatureMessages: ISpecialFeatureMessage[]) {
    if (!allMergedPerformances || allMergedPerformances.length < 1) return new Map<string, ISpecialFeatureMapValue>();;

    let specialFeatureMap = initializeMap(allMergedPerformances, specialFeatureMessages);
    specialFeatureMap = getSortedMap(specialFeatureMap);

    addSymbols(specialFeatureMap);

    return specialFeatureMap;
}

export function initializeMap(allMergedPerformances: IPerformance[], specialFeatureMessages: ISpecialFeatureMessage[]) {
    const specialFeatureMap = new Map<string, ISpecialFeatureMapValue>();

    for (let i = 0; i < allMergedPerformances.length; i++) {
        const performance = allMergedPerformances[i];
        const specialFeature = performance?.specialFeature?.toLowerCase().trim() ?? '';

        if (specialFeature) {
            if (specialFeatureMap.has(specialFeature)) {
                const mapValue = specialFeatureMap.get(specialFeature);

                specialFeatureMap.set(specialFeature, {
                    ...mapValue,
                    performanceCount: mapValue.performanceCount + 1,
                    performances: [...mapValue.performances, performance],
                });
            } else {
                specialFeatureMap.set(specialFeature, {
                    performanceCount: 1,
                    message: specialFeatureMessages
                        ?.filter(x => x.specialFeatureName?.toLowerCase().trim() === specialFeature)[0]?.specialFeatureMessage || specialFeature,
                    symbol: '',
                    performances: [performance],
                });
            }
        }
    }

    return specialFeatureMap;
}

export function getSortedMap(map: Map<string, ISpecialFeatureMapValue>) {
    return new Map([...map].sort((a, b) => {
        return b[1].performanceCount - a[1].performanceCount;
    }));
}

export function addSymbols(map: Map<string, ISpecialFeatureMapValue>) {
    if (!map) return;

    let symbol = '*';
    for (const [key] of map.entries()) {
        const mapValue = map.get(key);

        map.set(key, {
            ...mapValue,
            symbol,
        });

        symbol += '*';
    }
}